import { createSlice } from "@reduxjs/toolkit"

export const customerProfileListSlice = createSlice({
	name: "customerProfile_list",
	initialState: {
		customerProfile: "",
		errors: [],
	},

	reducers: {
        getCustomerProfile: (state, action) => {
            // console.log(action.payload);
			state.customerProfile = action.payload
		},
		getCustomerProfileList: (state, action) => {
            
			state.customerProfile = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getCustomerProfile, getCustomerProfileList, getErrors} = customerProfileListSlice.actions

export default customerProfileListSlice.reducer
